<template>
  <div>
    <vx-card>
      <el-row>
        <el-col>
          <el-form
            class="demo-form-inline"
            ref="form"
            label-width="30%"
            label-position="left"
            size="small"
          >
            <el-row type="flex" justify="space-around">
              <el-col :span="11">
                <el-form-item label="Supplier" v-if="select.withoutDocBc">
                  <span slot="label"
                    >{{ $t("pemasok") }}<span style="color: red">*</span></span
                  >
                  <el-select
                    style="width: 100%"
                    v-model="select.kodeSupplier"
                    filterable
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in optionPemasok"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Tanggal Masuk">
                  <span slot="label"
                    >{{ $t("incomingDate") }}
                    <span style="color: red">*</span></span
                  >
                  <DatePicker
                    size="small"
                    style="width: 100%"
                    :shortcuts="shortcuts"
                    :format="$formatDate"
                    :value="select.tglMasuk"
                    type="date"
                    placeholder="Select date"
                    v-model="select.tglMasuk"
                  ></DatePicker>
                </el-form-item>
                <el-form-item label="No Packing List">
                  <span slot="label"
                    >{{ $t("noPackingList") }}
                    <span style="color: red">*</span></span
                  >
                  <el-input
                    v-model="select.noPacking"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('remark')">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="remark"
                    v-model="select.remark"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item v-if="multipleWarehouse" label="type warehouse">
                  <el-select
                    v-model="select.typeWarehouse"
                    filterable
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in optionWarehouse"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="No Surat Jalan">
                  <span slot="label"
                    >{{ $t("noSuratJalan") }}
                    <span style="color: red">*</span></span
                  >
                  <el-input
                    v-model="select.noSuratJalan"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('noPenerimaanWarehouse')">
                  <el-input
                    v-model="select.noReceiving"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="No. AWB">
                  <el-input
                    v-model="select.noAwb"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" v-if="!isEdit">
                  <el-switch
                    @change="changeTanpaBc"
                    v-model="select.withoutDocBc"
                    :active-text="$t('tanpaDokumenBc')"
                    :inactive-text="$t('pakaiDokumenBc')"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-row>
            <el-col :span="24"
              ><div>
                <el-descriptions
                  v-if="select.noUrut"
                  :title="$t('pilihDokumenMasuk').toUpperCase()"
                  class="margin-top margin-bot mb-5"
                  :column="3"
                  size="medium"
                  border
                >
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-s-order"></i>
                      {{ $t("noAju").toUpperCase() }}
                    </template>
                    {{ select.noAju }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-date"></i>
                      {{ $t("docsDate").toUpperCase() }}
                    </template>
                    {{ $formatDatemoment(select.tglDokumen) }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-s-order"></i>
                      {{ $t("docsType").toUpperCase() }}
                    </template>
                    {{ select.idDokumen }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-s-order"></i>
                      {{ $t("noDocs").toUpperCase() }}
                    </template>
                    {{ select.noUrut }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-info"></i>
                      {{ $t("status").toUpperCase() }}
                    </template>
                    {{ select.status }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-s-custom"></i>
                      {{ $t("pemasok").toUpperCase() }}
                    </template>
                    <p>
                      {{ select.kodeSupplier + " - " + select.namaSupplier }}
                    </p>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-user"></i>
                      {{ $t("userInput").toUpperCase() }}
                    </template>
                    <p>{{ select.user }}</p>
                  </el-descriptions-item>
                </el-descriptions>
              </div></el-col
            >
          </el-row>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <vxe-toolbar>
            <template v-slot:buttons>
              <el-button
                v-if="!isEdit && !header.withoutDocBc"
                size="small"
                type="primary"
                icon="el-icon-search"
                v-on:click="$refs.modalDokSelect.openModal('dokBc')"
              >
                {{ $t("pilihDokBc").toUpperCase() }}</el-button
              >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                v-on:click="$refs.purchase.modalToggle()"
              >
                Select Purchase Order</el-button
              >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                v-if="$store.state.ppbkbMenu"
                v-on:click="$refs.modalDokSelect.openModal('ppbkb')"
              >
                Select PPKB IN</el-button
              >
            </template>
            <template v-slot:tools>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-circle-check"
                :disabled="bacaWh.length <= 0"
                @click.prevent="submitedData"
              >
                {{ $t("simpan").toUpperCase() }}</el-button
              >
            </template>
          </vxe-toolbar>
          <el-tabs>
            <el-tab-pane :label="$t('barangWarehouseList').toUpperCase()">
              <vxe-toolbar>
                <template #buttons>
                  <vs-input
                    size="small"
                    :label="$t('pilihExcelFile')"
                    type="file"
                    accept=".xlsx"
                    @change="previewFiles"
                  />
                  <el-button
                    class="ml-3 mt-4"
                    type="primary"
                    size="mini"
                    @click="exportExcel"
                  >
                    {{ $t("downloadFormat") }}</el-button
                  >
                  <!-- <el-checkbox
                    class="ml-3"
                    v-if="select.id"
                    v-model="tambahkanData"
                    >Menambahkan Data</el-checkbox
                  > -->
                </template>
              </vxe-toolbar>
              <vxe-table
                size="mini"
                :loading="loadingTableWh"
                empty-text="Empty Data "
                keep-source
                border
                resizable
                show-overflow
                show-header-overflow
                show-footer
                :footer-method="footerMethodBarangWh"
                ref="xTableWarehouse"
                height="400"
                row-key
                highlight-hover-row
                highlight-current-row
                :row-style="rowStyle"
                :row-config="{ isCurrent: true, isHover: true, height: 35 }"
                :column-config="{ resizable: true }"
                :data="bacaWh"
                :mouse-config="{ selected: true }"
                :checkbox-config="{
                  highlight: true,
                  range: true,
                }"
                :keyboard-config="{
                  isArrow: true,
                  isDel: true,
                  isEnter: true,
                  isTab: true,
                  isEdit: true,
                }"
                :edit-config="{
                  trigger: 'dblclick',
                  mode: 'cell',
                  showStatus: true,
                }"
                :scroll-y="{ mode: 'wheel' }"
                @cell-dblclick="onCellDblclick"
              >
                <vxe-column type="seq" fixed="left" width="60"></vxe-column>

                <vxe-column
                  width="100"
                  align="left"
                  header-align="center"
                  field="info"
                  :title="$t('info').toUpperCase()"
                >
                </vxe-column>

                <vxe-column
                  width="150"
                  align="center"
                  header-align="center"
                  field="delete"
                  title="DELETE"
                >
                  <template #default="{ row }">
                    <el-button
                      type="danger"
                      size="small"
                      @click="deleteData(row)"
                    >
                      Delete
                    </el-button>
                  </template>
                </vxe-column>
                <vxe-column
                  width="120"
                  align="left"
                  header-align="center"
                  field="kodeBarang"
                  :title="$t('code').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="200"
                  align="left"
                  header-align="center"
                  field="namaBarang"
                  :title="$t('deskripsi').toUpperCase()"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.namaBarang"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="kategori"
                  :title="$t('kategori').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="style"
                  :title="$store.state.styleName"
                  v-if="$store.state.availableStyle"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.style"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="color"
                  :title="$store.state.colorName"
                  v-if="$store.state.availableColor"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.color"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="size"
                  :title="$store.state.sizeName"
                  v-if="$store.state.availableSize"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.size"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="spec"
                  :title="$store.state.specName"
                  v-if="$store.state.availableSpec"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.spec"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="location"
                  title="LOCATION"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.location"
                      size="mini"
                      type="text"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="120"
                  align="center"
                  header-align="center"
                  field="satuan"
                  title="UNIT DOC"
                >
                </vxe-column>

                <vxe-column
                  width="150"
                  align="right"
                  header-align="center"
                  field="qtyInputWh"
                  :formatter="$$formatAmountBc"
                  :title="$t('qtyWh').toUpperCase()"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.qtyInputWh"
                      size="mini"
                      type="number"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  width="120"
                  align="center"
                  header-align="center"
                  field="satuanInputWh"
                  :title="$t('satuanWh').toUpperCase()"
                  :edit-render="{ autofocus: '#autocomplete' }"
                >
                  <template #edit="{ row }">
                    <el-autocomplete
                      id="autocomplete"
                      size="mini"
                      autosize
                      @blur="blurSatuan(row)"
                      v-model="row.satuanInputWh"
                      :fetch-suggestions="querySearchSatuan"
                      placeholder="Please Input"
                    ></el-autocomplete>
                  </template>
                </vxe-column>
                <vxe-column
                  width="150"
                  align="right"
                  header-align="center"
                  field="qtyOutWh"
                  :formatter="$$formatAmountBc"
                  :title="$t('qtyUsed')"
                >
                </vxe-column>
              </vxe-table>
            </el-tab-pane>
            <el-tab-pane
              :label="$t('barangDokumenList').toUpperCase()"
              v-if="!header.withoutDocBc"
            >
              <vxe-table
                size="mini"
                :loading="loadingTable"
                empty-text="Empty Data "
                keep-source
                border
                resizable
                show-overflow
                show-header-overflow
                show-footer
                :footer-method="footerMethodBarangDokumen"
                ref="xTable"
                height="400"
                row-key
                highlight-hover-row
                :row-style="rowStyle"
                highlight-current-row
                :row-config="{ isCurrent: true, isHover: true, height: 35 }"
                :column-config="{ resizable: true }"
                :data="baca"
                :mouse-config="{ selected: true }"
                :checkbox-config="{
                  highlight: true,
                  range: true,
                  checkMethod: checkMethodBaca,
                }"
                :keyboard-config="{
                  isArrow: true,
                  isDel: true,
                  isEnter: true,
                  isTab: true,
                  isEdit: true,
                }"
                :edit-config="{
                  trigger: 'dblclick',
                  mode: 'cell',
                  showStatus: true,
                }"
                :scroll-y="{ mode: 'wheel' }"
                @checkbox-all="getDataSelected"
                @checkbox-change="getDataSelected"
              >
                <vxe-column type="seq" fixed="left" width="60"></vxe-column>
                <vxe-column
                  header-align="left"
                  align="left"
                  type="checkbox"
                  fixed="left"
                  width="60"
                ></vxe-column>

                <vxe-column
                  width="120"
                  align="left"
                  header-align="center"
                  field="info"
                  :title="$t('info').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="120"
                  align="left"
                  header-align="center"
                  field="kodeBarang"
                  :title="$t('code').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="200"
                  align="left"
                  header-align="center"
                  field="namaBarang"
                  :title="$t('deskripsi').toUpperCase()"
                >
                </vxe-column>

                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="kategori"
                  :title="$t('kategori').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="style"
                  :title="$store.state.styleName"
                  v-if="$store.state.availableStyle"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="color"
                  :title="$store.state.colorName"
                  v-if="$store.state.availableColor"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="size"
                  :title="$store.state.sizeName"
                  v-if="$store.state.availableSize"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="spec"
                  :title="$store.state.specName"
                  v-if="$store.state.availableSpec"
                >
                </vxe-column>

                <vxe-column
                  width="150"
                  align="right"
                  header-align="center"
                  field="qty"
                  :formatter="$$formatAmountBc"
                  :title="$t('qtyDok').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="120"
                  align="center"
                  header-align="center"
                  field="satuan"
                  :title="$t('satuan').toUpperCase()"
                >
                </vxe-column>
                <vxe-column
                  width="100"
                  align="center"
                  header-align="center"
                  field="info"
                  :title="$t('INCOMING').toUpperCase()"
                >
                  <template #default="{ row }">
                    <el-button
                      size="mini"
                      type="primary"
                      v-if="row.info != 'OK'"
                      @click="incomingDetail(row)"
                    >
                      IN
                    </el-button>
                  </template>
                </vxe-column>
              </vxe-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>

      <div class="mt-3"></div>
    </vx-card>
    <SelectBarang jenis="all" ref="selectBarang" @sendData="changeBarang" />
    <ModalSelectPurchase
      ref="purchase"
      @selectedPurchase="handleSelectedPo"
      @selectedPurchaseHeader="handleSelectedPo"
    />
    <FindEqualsIncoming
      ref="modalDokSelect"
      @dokumenSelect="radioDokumenSelect"
    />
  </div>
</template>

<script>
import ModalSelectPurchase from "../barangmasuk/modalSelectPurchase.vue";
import SelectBarang from "../../components/other/SelectBarang.vue";
import vSelect from "vue-select";
import FindEqualsIncoming from "./FindEqualsIncoming.vue";
import axios from "axios";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Datepicker from "vuejs-datepicker";
import XLSX from "xlsx";
import moment from "moment";

export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    ModalSelectPurchase,
    SelectBarang,
    FindEqualsIncoming,
    vSelect,
    PerfectScrollbar,
    SweetModal,
    SweetModalTab,
    Datepicker,
  },
  data() {
    return {
      optionWarehouse: [],
      multipleWarehouse: false,
      tambahkanData: false,
      optionsSatuan: [],
      bacaWh: [],
      header: {
        withoutDocBc: false,
        noAwb: "",
        tglMasuk: new Date(),
        noSuratJalan: null,
        noPacking: null,
      },
      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],
      notDokumen: false,
      index: "",

      selectPo: [],
      contacts: [],
      tglAwal: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tglAkhir: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tglDocAwal: new Date(),
      tglDocAkhir: new Date(),
      optionPilihan: [
        {
          text: "Request",
          value: "request",
        },
        // {
        //   text: "JO",
        //   value: "wo"
        // },
        // {
        //   text: "Items",
        //   value: "items"
        // }
      ],
      pilihan: "",
      focuskurs: false,
      optionsCurrency: [],
      format: "yyyy-MM-dd",
      wodata: [],
      optionPemasok: [],
      optionStatus: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      pilihMaterial: [],
      pilihMaterial2: [],
      submitted: false,
      searchQuery: "",

      dataBarang: [],
      dataMaterial: [],
      selectBarangJadi: [],
      val: "",
      pemasok: "",
      noreg: "",

      tglPo: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      dueDate: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      noPo: null,
      ketOrder: "",
      tr: [],
      isEdit: false,
      keterangan: "",
      status: "",
      optionKalkulasi: [],
      baca: [],
      excelData: [],
      selectIndex: null,
      loadingTable: false,
      loadingTableWh: false,
      selectChange: null,
      select: {
        kodeSupplier: "",
        namaSupplier: "",
      },
    };
  },
  watch: {
    bacaWh: {
      handler(data) {
        this.baca.forEach((el) => {
          el.info = "OK";
          if (el.kodeBarang) {
            let find = this.bacaWh.find((f) => f.kodeBarang == el.kodeBarang);
            if (!find) {
              el.info = "Barang belum ada di list incoming";
            }
          }
        });
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    changeTanpaBc() {
      localStorage.setItem("incomingTanpaBc", this.select.withoutDocBc);
    },
    handleSelectedPo(data) {
      if (Array.isArray(data)) {
        for (let elm of data) {
          this.prosesSelectPo(elm);
        }
      } else {
        this.prosesSelectPo(data);
      }
    },
    prosesSelectPo(data) {
      if (data.kodeSupplier) {
        this.select.kodeSupplier = data.kodeSupplier;
      }
      const newData = {
        ...data,

        qtyInputWh: data.qtyBalanceExim,
        satuanInputWh: data.satuan,
        idAsalPo: data.idPo,
      };

      delete newData.id;

      this.bacaWh.push(newData);
      this.$vs.notify({
        title: "SELECTED",
        text: `DESCRIPTION: ${
          data.namaBarang != undefined ? data.namaBarang : data.namaMaterial
        }<br>CODE: ${
          data.kodeMaterial == undefined ? data.kodeBarang : data.kodeMaterial
        }`,
      });
    },
    incomingDetail(row) {
      let newElm = { ...row };
      delete newElm["_X_ROW_KEY"];
      newElm.qtyInputWh = newElm.qty;
      newElm.satuanInputWh = newElm.satuanWh || newElm.satuan;
      newElm.idAsal = newElm.id;
      newElm.info = "OK";
      delete newElm.id;

      this.bacaWh.push(newElm);
    },
    onCellDblclick({ row, column }) {
      if (column.field == "kodeBarang") {
        this.selectChange = row;
        this.$refs.selectBarang.openModal();
      }
    },
    changeBarang(data) {
      let find = this.bacaWh.find(
        (f) => f._X_ROW_KEY == this.selectChange._X_ROW_KEY
      );
      if (find) {
        find.kodeBarang = data.kodeBarang;
        find.namaBarang = data.namaBarang;
        find.satuanInputWh = data.satuan;
        this.$refs.selectBarang.closeModal();
      }
    },
    deleteData(row) {
      if (!row.id) {
        this.bacaWh = this.bacaWh.filter((f) => f._X_ROW_KEY != row._X_ROW_KEY);
      } else {
        row.isDeleted = !row.isDeleted;
      }
    },
    footerMethodBarangDokumen({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (["qty"].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    footerMethodBarangWh({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 7) {
            return "TOTAL";
          }
          if (["qtyInputWh"].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    async getSatuan() {
      const get = await this.$api.get("api/v1/masterdata/unit");

      this.optionsSatuan = [];
      get.data.forEach((elm) => {
        this.optionsSatuan.push({
          text: elm.kodeUnit,
          label: elm.kodeUnit,
          value: elm.kodeUnit,
        });
      });

      // console.log(this.optionsBrand);
    },
    createFilterSatuan(queryString) {
      return (link) => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    querySearchSatuan(queryString, cb) {
      var links = this.optionsSatuan;
      var results = queryString
        ? links.filter(this.createFilterSatuan(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    blurSatuan(row) {
      if (row.satuan == null) {
        row.satuan = "";
      }
      let cek = this.optionsSatuan.filter(
        (f) => f.value.toLowerCase() == row.satuan.toLowerCase()
      );
      if (cek.length <= 0) {
        row.satuan = row.satuan.toUpperCase();
        // return this.$notify({
        //   title: "WARNING",
        //   message: "Please input according to choice  ",
        //   offset: 200,
        //   type: "warning",
        // });
      } else {
        row.satuan = cek[0].value;
      }
    },
    async previewFiles(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      if (!this.isEdit) {
        this.bacaWh = [];
      } else {
        this.bacaWh = this.bacaWh.filter((f) => f.id);
      }
      let tmp0 = [];
      let t = this;
      this.loadingTableWh = true;
      try {
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );

          elements.forEach((el, i) => {
            t.bacaWh.push({
              kodeBarang: el["ITEM CODE"],
              namaBarang: el["ITEM NAME"],
              style: el["STYLE"],
              color: el["COLOR"],
              size: el["SIZE"],
              spec: el["SPEC"],
              location: el["LOCATION"],
              satuanInputWh: el["UNIT"],
              qtyInputWh: el["QTY"],
              index: i,
              info: "OK",
            });
          });

          t.loadingTableWh = false;
          t.validasiDataWh();
        };
        // this.excelData = JSON.parse(JSON.stringify(tmp0));

        this.loadingTableWh = false;
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },
    validasiDataWh() {
      this.bacaWh.forEach((elm) => {
        if (!elm.kodeBarang) elm.info = "Kode barang diperlukan";
        if (!elm.qtyInputWh) elm.info = "Qty diperlukan";
        if (!elm.satuanInputWh) elm.info = "Satuan diperlukan";
        if (elm.kodeBarang) {
          let findBarang = this.baca.find(
            (f) => f.kodeBarang == elm.kodeBarang
          );
          if (!findBarang) {
            // elm.info = "Kode barang tidak ditemukan pada data dokumen";
          } else {
            elm.idAsal = findBarang.idAsal;
            if (!elm.namaBarang) elm.namaBarang = findBarang.namaBarang;
          }
        }
      });
    },
    exportExcel() {
      let headers = [
        {
          "ITEM CODE": "",
          "ITEM NAME": "",
          STYLE: "",
          COLOR: "",
          SIZE: "",
          SPEC: "",
          LOCATION: "",
          UNIT: "",
          QTY: "",
        },
      ];
      const data = XLSX.utils.json_to_sheet(headers);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "Format Upload Item Warehouse.xlsx");
    },
    inputReel(row) {
      if (row.listReel == null) {
        row.listReel = [];
      }
      this.selectIndex = row;

      this.$refs.modalReel.open();
    },
    async setFormValue(data) {
      this.isEdit = true;
      data.listDetail.forEach((elm) => {
        elm.info = "OK";
      });
      this.select = data;
      // this.header = data;
      this.bacaWh = data.listDetail;

      let filter = {
        noReg: data.noRegDokumen,
      };
      if (!data.noRegDokumen) {
        filter = {
          noAju: data.noAju,
        };
      }

      let get = await this.$api.get(
        "api/v1/warehouse/barangmasuk/dokumen/search",
        {
          params: filter,
        }
      );
      get.data.content[0].listDetail.forEach((el) => {
        el.info = "OK";
        if (el.kodeBarang) {
          let find = this.bacaWh.find((f) => f.kodeBarang == el.kodeBarang);
          if (!find) {
            el.info = "Barang belum ada di list incoming";
          }
        }
      });
      this.baca = get.data.content[0].listDetail;
    },
    radioDokumenSelect(row) {
      this.baca = [];
      this.bacaWh = [];
      this.select = { ...row };

      // if (row.noPacking) {
      //   this.header.noPacking = row.noPacking;
      // }

      // if (row.noSuratJalan) {
      //   this.header.noSuratJalan = row.noSuratJalan;
      // }

      row.listDetail.forEach((e) => {
        let newElm = { ...e };
        delete newElm["_X_ROW_KEY"];
        newElm.qtyInputWh = newElm.qty;
        newElm.satuanInputWh = newElm.satuanWh || newElm.satuan;

        if (this.$store.state.ppbkbMenu) {
          newElm.idPpbkb = newElm.id;
        } else {
          newElm.idAsal = newElm.id;
        }

        newElm.info = "OK";

        delete newElm.id;

        this.baca.push(newElm);
        this.bacaWh.push(newElm);
      });
      if (!this.$store.state.ppbkbMenu) {
        this.select.idHeaderPpbkb = this.select.id;
      } else {
        this.select.idHeaderDokumen = this.select.id;
      }
      console.log(this.select);
      this.$notify({
        offset: 200,
        title: "SUCCESS",
        type: "success",
        message: "Selected " + row.noUrut,
      });
    },

    editMethod({ row, column }) {
      // 重写默认的覆盖式，改为追加式
      this.$refs.xTable.setActiveCell(row, column.property);
      // 返回 false 阻止默认行为
      return false;
    },
    formatterNum({ cellValue }) {
      return this.$formatAngka(cellValue);
    },
    getDataSelected({ checked, records }) {
      this.itemSelected = records;
    },
    getDataSelectedDoc({ checked, records, row }) {
      this.baca = this.baca.filter((f) => f.idAsal == null);
      records.forEach((e) => {
        let req = { ...e };
        req["idAsal"] = e.id;
        req["qty"] = e.qty - e.qtyOut;
        req["qtyDoc"] = e.qty - e.qtyOut;
        req["satuan"] = e.satuan;
        req["satuanWh"] = e.satuan;

        delete req["  _X_ROW_KEY"];
        delete req["id"];
        delete req["noReg"];
        this.baca.push(req);
      });

      this.$vs.notify({
        title: `CODE ${row.kodeBarang}`,
        text: `DESC: ${row.namaBarang} ${row.noReg}`,
      });
    },
    checkMethodBaca({ row }) {
      return row.idAsal == null;
    },

    querySearchCurrency(queryString, cb) {
      var links = this.optionsCurrency;
      var results = queryString
        ? links.filter(this.createFilterCurrency(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterCurrency(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    blurCurrency(row) {
      if (row.currency == null) {
        row.currency = "";
      }
      let cek = this.optionsCurrency.filter(
        (f) => f.value.toLowerCase() == row.currency.toLowerCase()
      );
      if (cek.length <= 0) {
        row.currency = row.currency.toUpperCase();
        // return this.$notify({
        //   title: "WARNING",
        //   message: "Please input according to choice  ",
        //   offset: 200,
        //   type: "warning",
        // });
      } else {
        row.currency = cek[0].value;
      }
    },

    cekTanggalDoc() {
      if (this.tglDocAwal > this.tglDocAkhir) {
        this.tglDocAwal = this.tglDocAkhir;
        this.$vs.notify({
          text: this.$t("silahkanPilihTanggalYangSesuai"),
          color: "warning",
        });
      } else {
        this.baca = this.baca.filter((f) => f.idAsal == null);
        this.getDokumen();
      }
    },

    hapusdetailwo(id) {
      this.baca = this.baca.filter((f) => {
        return f.id != id;
      });
    },
    changeFocus() {
      this.focuskurs = true;
      // console.log("ok");
    },
    changeBlur() {
      this.focuskurs = false;
      // console.log("kasd");
    },

    async getCurrency() {
      const get = await this.$api.get("api/v1/masterdata/currency");

      this.optionsCurrency = [];
      get.data.forEach((elm) => {
        this.optionsCurrency.push({
          text: elm.currency,
          label: elm.currency,
          value: elm.currency,
        });
      });

      // console.log(this.optionsBrand);
    },
    totalEquals(row) {
      let price =
        row.price == null || row.price == undefined || isNaN(row.price)
          ? 0.0
          : parseFloat(row.price);

      row.amount = price * row.qty;
    },

    async getPemasok() {
      await this.$api
        .get("/api/v1/masterdata/supplier")
        .then((response) => {
          Object.values(response.data).forEach((key) => {
            this.optionPemasok.push({
              namaSupplier: key.namaSupplier,
              kodeSupplier: key.kodeSupplier,
              text: key.namaSupplier,
              value: `${key.kodeSupplier}`,
              label: `${key.kodeSupplier}-${key.namaSupplier}`,
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    notifwarning(title, text) {
      this.$vs.notify({
        color: "danger",
        title: title,
        text: text,
      });
    },
    rowStyle({ row }) {
      if (row.info != "OK" && this.select.noUrut) {
        return {
          backgroundColor: "red",
          color: "white",
        };
      }
      if (row.isDeleted) {
        return {
          backgroundColor: "red",
          color: "black",
        };
      }
    },
    async submitedData() {
      this.select["listDetail"] = this.bacaWh;
      // this.select["noSuratJalan"] = this.header.noSuratJalan;
      // this.select["noPacking"] = this.header.noPacking;
      // this.select["noKontrak"] = this.header.noKontrak;
      // this.select["noReceiving"] = this.header.noReceiving;
      // this.select["tglMasuk"] = this.header.tglMasuk;
      // this.select["noAwb"] = this.header.noAwb;
      // this.select["tglPenerimaan"] = this.header.tglMasuk;
      // this.select["listDetail"] = this.bacaWh;
      // this.select.withoutDocBc = this.header.withoutDocBc;

      if (this.select.withoutDocBc) {
        // this.select.kodeSupplier = this.header.kodeSupplier;
        let supp = this.optionPemasok.find(
          (f) => f.kodeSupplier == this.select.kodeSupplier
        );
        if (supp) {
          this.select.namaSupplier = supp.namaSupplier;
        }
      }

      if (!this.isEdit && !this.select.withoutDocBc) {
        this.select["noRegDokumen"] = this.select.noReg;
        delete this.select.id;
      }
      for (let el of this.bacaWh) {
        if (el.info != "OK" && this.select.noUrut) {
          return this.notifValidasi("Data Warehouse Tidak Valid", true);
        }
      }
      this.$emit("submitedData", this.select);
    },
    async getWarehouse() {
      const res = await this.$api.get("api/v1/masterdata/warehouse");
      this.optionWarehouse = res.data.map((v) => {
        v.value = v.warehouse;
        v.label = v.warehouse;
        return v;
      });
    },
  },

  mounted() {
    if (this.$store.state.multipleWarehouse) {
      this.multipleWarehouse = true;
      this.getWarehouse();
    }
    if (!this.isEdit) {
      let getTanpaBc = localStorage.getItem("incomingTanpaBc");
      if (getTanpaBc) {
        this.select.withoutDocBc = true;
      }
    }
    this.tglAkhir = new Date();
    var date = new Date();
    date.setDate(date.getDate() - 1);

    this.tglAwal = date;

    this.tglDocAkhir = new Date();
    var date = new Date();
    date.setDate(date.getDate() - 1);

    this.tglDocAwal = date;

    this.tglPo = new Date();
    this.dueDate = new Date();
    this.getPemasok();

    this.getCurrency();

    this.getSatuan();

    //
  },
};
</script>
<style>
.tengah {
  text-align: center;
}
</style>
